import { sendPasswordResetEmail } from "firebase/auth";
import { FloatingBackButton } from "../components/FloatingBackButton";
import { firebaseAuth } from "../firebase";
import { FirebaseError } from "firebase/app";
import { useState } from "react";

export const ResetPassword = () => {
  const [badEmail, setBadEmail] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [sent, setSent] = useState(false);

  const onChange = () => {
    const email = (document.getElementById("email") as HTMLInputElement).value;
    if (!email) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  };

  const send = async () => {
    try {
      const email = (document.getElementById("email") as HTMLInputElement)
        .value;
      await sendPasswordResetEmail(firebaseAuth, email);
      alert("보내드렸습니다~");
      setSent(true);
    } catch (error) {
      switch ((error as FirebaseError).code) {
        case "auth/user-not-found":
        case "auth/wrong-password":
        case "auth/weak-password":
          alert("이메일 혹은 비밀번호가 일치하지 않습니다.");
          return;
        case "auth/network-request-failed":
          alert("네트워크 연결에 실패 하였습니다.");
          return;
        case "auth/invalid-email":
          setBadEmail(true);
          return;
        case "auth/internal-error":
        default:
          alert("로그인에 실패하였습니다.");
          return;
      }
    }
  };

  return (
    <div className="form">
      <FloatingBackButton />
      <header>
        <span className="header">비밀번호 재설정</span>
        <span style={{ textAlign: "center" }}>
          오르조에 가입한 이메일 주소를 입력해주세요.
          <br />
          이메일 링크를 통해 재설정할 수 있습니다.
        </span>
        <span></span>
      </header>
      <input
        className="input-group"
        id="email"
        type="email"
        name="email"
        placeholder="이메일"
        onChange={() => {
          onChange();
          setBadEmail(false);
        }}
        onSubmit={send}
        onKeyDown={(e) => {
          if (e.key === "Enter") send();
        }}
        style={
          badEmail
            ? {
                borderColor: "var(--caution)",
              }
            : undefined
        }
      />
      {badEmail && (
        <span className="input-error">잘못된 이메일 형식입니다.</span>
      )}
      <button
        disabled={disabled || sent}
        id="submit"
        className="submit primary"
        onClick={send}
      >
        이메일 전송
      </button>
    </div>
  );
};
